import GET_ARTICLES from "../plugins/getArticles"

const [ w, d ] = [ window, document ]

const init = () => {

  $.when( w.load['recruit'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="recruit-guideline-item">
        <figure class="recruit-guideline-item__img">
          <div class="recruit-guideline-item__img-cover" style="background-image:url(${item.thumb})">
            <img src="${item.thumb}" alt="${item.title}" width="300" loading="lazy">
          </div>
        </figure>
        <div class="recruit-guideline-item__body">
          <h4 class="subject">
            <span>${item.title.str_truncate(24)}</span>
            <svg class="icon" width="20" height="20">
              <use xlink:href="/asset/svg/sprite.symbol.svg#icon-arrow-right-circle-w"></use>
            </svg>
          </h4>
          <span class="desc">${item.desc}</span>
        </div>
    </a>
    `)[0]
    GET_ARTICLES( '.recruit-guideline__list[data-plugin="getArticles"]', { makeItem }).then(
      items => {
        if ( items.length == 0) {
          $('.recruit-guideline, .recruit-entry').hide()
        }
      }
    )
  })
}

export default function RECRUIT() {
  $( init )
}